import { render, staticRenderFns } from "./ProjectInformationCard.vue?vue&type=template&id=2c20078c&scoped=true"
import script from "./ProjectInformationCard.vue?vue&type=script&lang=js"
export * from "./ProjectInformationCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectInformationCard.vue?vue&type=style&index=0&id=2c20078c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20078c",
  null
  
)

export default component.exports